// Mirrors the grants the backend makes through studio_credit.TopUp; the copy
// quotes them, so they have to change together.
export const REFERRAL_SIGNUP_CREDITS = 15;
export const REFERRAL_PAID_CREDITS = 100;
